import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { useAttrs } from "vue";
import LoadingSpinner from "./loading-spinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'submit-button',
  props: {
    isSubmitted: { type: Boolean },
    buttonClass: {},
    useRecaptcha: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps({
    class: ["btn", [{ 'btn-loading': props.isSubmitted }, props.buttonClass]]
  }, _unref(attrs), {
    type: "submit",
    disabled: props.disabled
  }), [
    (props.isSubmitted)
      ? (_openBlock(), _createBlock(LoadingSpinner, {
          key: 0,
          size: "25px"
        }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 16, _hoisted_1))
}
}

})